/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Make_PublicInputs */

const en_document_make_public = /** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make Public`)
};

const id_document_make_public = /** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadikan Publik`)
};

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const es_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const fr_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const de_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const ja_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const zh_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const ar_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const it_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const ru_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const pt_document_make_public = en_document_make_public;

/** @type {(inputs: Document_Make_PublicInputs) => LocalizedString} */
const ko_document_make_public = en_document_make_public;

/**
* | output |
* | --- |
* | "Make Public" |
*
* @param {Document_Make_PublicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_make_public = /** @type {((inputs?: Document_Make_PublicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Make_PublicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_make_public(inputs)
	if (locale === "es") return es_document_make_public(inputs)
	if (locale === "fr") return fr_document_make_public(inputs)
	if (locale === "de") return de_document_make_public(inputs)
	if (locale === "ja") return ja_document_make_public(inputs)
	if (locale === "zh") return zh_document_make_public(inputs)
	if (locale === "ar") return ar_document_make_public(inputs)
	if (locale === "id") return id_document_make_public(inputs)
	if (locale === "it") return it_document_make_public(inputs)
	if (locale === "ru") return ru_document_make_public(inputs)
	if (locale === "pt") return pt_document_make_public(inputs)
	return ko_document_make_public(inputs)
});